module.exports = __webpack_public_path__ + "static/media/NSUT_logo.26eb6de4.png";